import ProductList from "../../components/products/product.list";

const ProductPage = () => {
  return <ProductList />;
};

export default ProductPage;
